<template>
  <div
    v-if="isShow"
    ref="contextmenuRef"
    class="contextmenuContainer listBox"
    :style="{ left: left + 'px', top: top + 'px' }"
    :class="{ isDark: isDark }"
  >
    <template v-if="type === 'node'">
      <div
        v-if="nodeIsModule"
        class="item"
        :class="{ disabled: isGeneralization }"
        @click="exec('ADD_CASE_NODE')"
      >
        <span class="name">新增用例</span>
        <!-- <span class="desc">Tab</span> -->
      </div>
      <div
        v-if="nodeIsCase"
        class="item"
        :class="{ disabled: isGeneralization }"
        @click="exec('ADD_CASE_STEP')"
      >
        <span class="name">新增步骤</span>
        <!-- <span class="desc">Tab</span> -->
      </div>
      <div
        v-if="false"
        class="item"
        :class="{ disabled: insertNodeBtnDisabled }"
        @click="exec('INSERT_NODE', insertNodeBtnDisabled)"
      >
        <span class="name">插入同级节点</span>
        <span class="desc">Enter</span>
      </div>
      <div
        v-if="false"
        class="item"
        :class="{ disabled: isGeneralization }"
        @click="exec('INSERT_CHILD_NODE')"
      >
        <span class="name">插入子级节点</span>
        <span class="desc">Tab</span>
      </div>
      <div
        v-if="false"
        class="item"
        :class="{ disabled: insertNodeBtnDisabled }"
        @click="exec('INSERT_PARENT_NODE')"
      >
        <span class="name">插入父节点</span>
        <span class="desc">Shift + Tab</span>
      </div>
      <div class="splitLine" />
      <div
        class="item"
        :class="{ disabled: upNodeBtnDisabled }"
        @click="exec('UP_NODE')"
      >
        <span class="name">上移节点</span>
        <span class="desc">Ctrl + ↑</span>
      </div>
      <div
        class="item"
        :class="{ disabled: downNodeBtnDisabled }"
        @click="exec('DOWN_NODE')"
      >
        <span class="name">下移节点</span>
        <span class="desc">Ctrl + ↓</span>
      </div>
      <div class="item" @click="exec('UNEXPAND_ALL')">
        <span class="name">收起所有下级节点</span>
      </div>
      <div class="item" @click="exec('EXPAND_ALL')">
        <span class="name">展开所有下级节点</span>
      </div>
      <div v-if="supportNumbers" class="item">
        <span class="name">编号其子节点</span>
        <span class="el-icon-arrow-right" />
        <div
          class="subItems listBox"
          :class="{ isDark: isDark, showLeft: subItemsShowLeft }"
          style="top: -170px"
        >
          <div
            v-for="item in numberTypeList"
            :key="'type' + item.value"
            class="item"
            @click="setNodeNumber('type', item.value)"
          >
            <span class="name">{{ item.name }}</span>
            {{ numberType === item.value ? '√' : '' }}
          </div>
          <div class="splitLine" />
          <div
            v-for="item in numberLevelList"
            :key="'level' + item.value"
            class="item"
            :class="{ disabled: numberType === '' }"
            @click="setNodeNumber('level', item.value)"
          >
            <span class="name">{{ item.name }}</span>
            {{ numberLevel === item.value ? '√' : '' }}
          </div>
        </div>
      </div>
      <div class="splitLine" />
      <div class="item danger" @click="exec('REMOVE_NODE')">
        <span class="name">删除节点</span>
        <span class="desc">Delete</span>
      </div>
      <div class="splitLine" />
      <div
        class="item"
        :class="{ disabled: isGeneralization }"
        @click="exec('COPY_NODE')"
      >
        <span class="name">复制节点</span>
        <span class="desc">Ctrl + C</span>
      </div>
      <div
        class="item"
        :class="{ disabled: isGeneralization }"
        @click="exec('CUT_NODE')"
      >
        <span class="name">剪切节点</span>
        <span class="desc">Ctrl + X</span>
      </div>
      <div class="item" @click="exec('PASTE_NODE')">
        <span class="name">粘贴节点</span>
        <span class="desc">Ctrl + V</span>
      </div>
      <div class="splitLine" />
      <div v-if="hasHyperlink" class="item" @click="exec('REMOVE_HYPERLINK')">
        <span class="name">移除超链接</span>
      </div>
      <div v-if="hasNote" class="item" @click="exec('REMOVE_NOTE')">
        <span class="name">移除备注</span>
      </div>
      <div class="item" @click="exec('EXPORT_CUR_NODE_TO_PNG')">
        <span class="name">导出该节点为图片</span>
      </div>
    </template>
    <template v-if="type === 'svg'">
      <div
        v-if="nodeIsModule"
        class="item"
        :class="{ disabled: isGeneralization }"
        @click="exec('ADD_CASE_NODE')"
      >
        <span class="name">新增用例</span>
        <!-- <span class="desc">Tab</span> -->
      </div>
      <div class="item" @click="exec('RETURN_CENTER')">
        <span class="name">回到根节点</span>
        <span class="desc">Ctrl + Enter</span>
      </div>
      <div class="splitLine" />
      <div class="item" @click="exec('EXPAND_ALL')">
        <span class="name">展开所有</span>
      </div>
      <div class="item" @click="exec('UNEXPAND_ALL')">
        <span class="name">收起所有</span>
      </div>
      <div class="item">
        <span class="name">展开到</span>
        <span class="el-icon-arrow-right" />
        <div
          class="subItems listBox"
          :class="{ isDark: isDark, showLeft: subItemsShowLeft }"
          style="top: -10px"
        >
          <div
            v-for="(item, index) in expandList"
            :key="item"
            class="item"
            @click="exec('UNEXPAND_TO_LEVEL', false, index + 1)"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="splitLine" />
      <div class="item" @click="exec('RESET_LAYOUT')">
        <span class="name">一键整理布局</span>
        <span class="desc">Ctrl + L</span>
      </div>
      <div class="item" @click="exec('FIT_CANVAS')">
        <span class="name">适应画布</span>
        <span class="desc">Ctrl + i</span>
      </div>
      <div class="splitLine" />
      <div class="item">
        <span class="name">复制到剪贴板</span>
        <span class="el-icon-arrow-right" />
        <div
          class="subItems listBox"
          :class="{ isDark: isDark, showLeft: subItemsShowLeft }"
          style="top: -130px"
        >
          <div
            v-for="item in copyList"
            :key="item.value"
            class="item"
            @click="copyToClipboard(item.value)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { getTextFromHtml, imgToDataUrl } from 'simple-mind-map/src/utils';
import { transformToMarkdown } from 'simple-mind-map/src/parse/toMarkdown';
import { transformToTxt } from 'simple-mind-map/src/parse/toTxt';
import { setDataToClipboard, setImgToClipboard, copy } from '../utils';
import { numberTypeList, numberLevelList } from '../config';

export default {
  name: 'Contextmenu',
  props: {
    mindMap: {
      type: Object
    }
  },
  data() {
    return {
      isDark: false,
      isShow: false,
      left: 0,
      top: 0,
      node: null,
      type: 'node',
      isMousedown: false,
      mosuedownX: 0,
      mosuedownY: 0,
      enableCopyToClipboardApi: navigator.clipboard,
      numberType: '',
      numberLevel: '',
      subItemsShowLeft: false
    };
  },
  computed: {
    ...mapState({
      isZenMode: state => state.localConfig.isZenMode,
      supportNumbers: state => state.supportNumbers,
      supportCheckbox: state => state.supportCheckbox
    }),
    nodeIsCase() {
      if (this.node && this.node.nodeData && this.node.nodeData.data &&
       this.node.nodeData.data.tag) {
        const _data = JSON.parse(JSON.stringify(this.node.nodeData.data.tag));
        if (_data && _data.length > 0) {
          return _data[0].text === '用例';
        }
      }
      return false;
    },
    nodeIsModule() {
      if (this.node && this.node.nodeData && this.node.nodeData.data &&
       this.node.nodeData.data.tag) {
        const _data = JSON.parse(JSON.stringify(this.node.nodeData.data.tag));
        if (_data && _data.length > 0) {
          return _data[0].text === '模块';
        }
      }
      return false;
    },
    expandList() {
      return [
        '一级主题',
        '二级主题',
        '三级主题',
        '四级主题',
        '五级主题',
        '六级主题'
      ];
    },
    copyList() {
      const list = [
        {
          name: 'JSON',
          value: 'json'
        }
      ];
      if (this.enableCopyToClipboardApi) {
        list.push({
          name: '图片',
          value: 'png'
        });
      }
      return list;
    },
    insertNodeBtnDisabled() {
      return !this.node || this.node.isRoot || this.node.isGeneralization;
    },
    upNodeBtnDisabled() {
      if (!this.node || this.node.isRoot || this.node.isGeneralization) {
        return true;
      }
      const isFirst =
        this.node.parent.children.findIndex(item => {
          return item === this.node;
        }) === 0;
      return isFirst;
    },
    downNodeBtnDisabled() {
      if (!this.node || this.node.isRoot || this.node.isGeneralization) {
        return true;
      }
      const children = this.node.parent.children;
      const isLast =
        children.findIndex(item => {
          return item === this.node;
        }) ===
        children.length - 1;
      return isLast;
    },
    isGeneralization() {
      return this.node.isGeneralization;
    },
    hasHyperlink() {
      return !!this.node.getData('hyperlink');
    },
    hasNote() {
      return !!this.node.getData('note');
    },
    numberTypeList() {
      return numberTypeList[this.$i18n.locale] || numberTypeList.zh;
    },
    numberLevelList() {
      return numberLevelList[this.$i18n.locale] || numberLevelList.zh;
    },
    hasCheckbox() {
      return !!this.node.getData('checkbox');
    }
  },
  created() {
    this.$bus.$on('node_contextmenu', this.show);
    this.$bus.$on('node_click', this.hide);
    this.$bus.$on('draw_click', this.hide);
    this.$bus.$on('expand_btn_click', this.hide);
    this.$bus.$on('svg_mousedown', this.onMousedown);
    this.$bus.$on('mouseup', this.onMouseup);
    this.$bus.$on('translate', this.hide);
  },
  beforeDestroy() {
    this.$bus.$off('node_contextmenu', this.show);
    this.$bus.$off('node_click', this.hide);
    this.$bus.$off('draw_click', this.hide);
    this.$bus.$off('expand_btn_click', this.hide);
    this.$bus.$off('svg_mousedown', this.onMousedown);
    this.$bus.$off('mouseup', this.onMouseup);
    this.$bus.$off('translate', this.hide);
  },
  methods: {
    ...mapMutations(['setLocalConfig']),

    // 计算右键菜单元素的显示位置
    getShowPosition(x, y) {
      const rect = this.$refs.contextmenuRef.getBoundingClientRect();
      if (x + rect.width > window.innerWidth) {
        x = x - rect.width - 20;
      }
      this.subItemsShowLeft = x + rect.width + 150 > window.innerWidth;
      if (y + rect.height > window.innerHeight) {
        y = window.innerHeight - rect.height - 10;
      }
      return { x, y };
    },

    // 节点右键显示
    show(e, node) {
      this.type = 'node';
      this.isShow = true;
      this.node = node;
      const number = this.node.getData('number');
      if (number) {
        this.numberType = number.type || 1;
        this.numberLevel = number.level === '' ? 1 : number.level;
      }
      this.$nextTick(() => {
        const { x, y } = this.getShowPosition(e.clientX + 10, e.clientY + 10);
        this.left = x;
        this.top = y;
      });
    },

    // 鼠标按下事件
    onMousedown(e) {
      if (e.which !== 3) {
        return;
      }
      this.mosuedownX = e.clientX;
      this.mosuedownY = e.clientY;
      this.isMousedown = true;
    },

    // 鼠标松开事件
    onMouseup(e) {
      if (!this.isMousedown) {
        return;
      }
      this.isMousedown = false;
      if (
        Math.abs(this.mosuedownX - e.clientX) > 3 ||
        Math.abs(this.mosuedownY - e.clientY) > 3
      ) {
        this.hide();
        return;
      }
      // this.show2(e);
    },

    // 画布右键显示
    show2(e) {
      this.type = 'svg';
      this.isShow = true;
      this.$nextTick(() => {
        const { x, y } = this.getShowPosition(e.clientX + 10, e.clientY + 10);
        this.left = x;
        this.top = y;
      });
    },

    // 隐藏
    hide() {
      this.isShow = false;
      this.left = -9999;
      this.top = -9999;
      this.type = '';
      this.node = '';
      this.numberType = '';
      this.numberLevel = '';
    },

    // 执行命令
    exec(key, disabled, ...args) {
      if (disabled) {
        return;
      }
      switch (key) {
        // case 'ADD_CASE_NODE':
        //   this.addCaseNode();
        //   break;
        case 'COPY_NODE':
          this.mindMap.renderer.copy();
          break;
        case 'CUT_NODE':
          this.mindMap.renderer.cut();
          break;
        case 'PASTE_NODE':
          this.mindMap.renderer.paste();
          break;
        case 'RETURN_CENTER':
          this.mindMap.renderer.setRootNodeCenter();
          break;
        case 'TOGGLE_ZEN_MODE':
          this.setLocalConfig({
            isZenMode: !this.isZenMode
          });
          break;
        case 'FIT_CANVAS':
          this.mindMap.view.fit();
          break;
        case 'REMOVE_HYPERLINK':
          this.node.setHyperlink('', '');
          break;
        case 'REMOVE_NOTE':
          this.node.setNote('');
          break;
        case 'EXPORT_CUR_NODE_TO_PNG':
          this.mindMap.export(
            'png',
            true,
            getTextFromHtml(this.node.getData('text')),
            false,
            this.node
          );
          break;
        case 'UNEXPAND_ALL':
          const uid = this.node ? this.node.uid : '';
          this.$bus.$emit('execCommand', key, !uid, uid);
          break;
        case 'EXPAND_ALL':
          this.$bus.$emit('execCommand', key, this.node ? this.node.uid : '');
          break;
        default:
          this.$bus.$emit('execCommand', key, ...args);
          break;
      }
      this.hide();
    },

    // 设置节点编号
    setNodeNumber(prop, value) {
      if (prop === 'type') {
        this.numberType = value;
        if (value === '') {
          // 无编号
          this.numberLevel = '';
          this.mindMap.execCommand('SET_NUMBER', [], null);
          return;
        } else {
          // 有编号
          if (this.numberLevel === '') {
            this.numberLevel = 1;
          }
        }
      }
      if (prop === 'level') {
        this.numberLevel = value;
      }
      this.mindMap.execCommand('SET_NUMBER', [], {
        [prop]: value
      });
      this.hide();
    },

    // 设置待办
    setCheckbox() {
      this.mindMap.execCommand(
        'SET_CHECKBOX',
        [],
        this.hasCheckbox
          ? null
          : {
            done: false
          }
      );
      this.hide();
    },

    // 复制到剪贴板
    async copyToClipboard(type) {
      try {
        this.hide();
        let data;
        let str;
        switch (type) {
          case 'smm':
          case 'json':
            data = this.mindMap.getData(true);
            str = JSON.stringify(data);
            break;
          case 'md':
            data = this.mindMap.getData();
            str = transformToMarkdown(data);
            break;
          case 'txt':
            data = this.mindMap.getData();
            str = transformToTxt(data);
            break;
          case 'png':
            const png = await this.mindMap.export('png', false);
            const blob = await imgToDataUrl(png, true);
            setImgToClipboard(blob);
            break;
          default:
            break;
        }
        if (str) {
          if (this.enableCopyToClipboardApi) {
            setDataToClipboard(str);
          } else {
            copy(str);
          }
        }
        this.$message.success('复制成功');
      } catch (error) {
        console.log(error);
        this.$message.error('复制失败');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.listBox {
  width: 250px;
  background: #fff;
  box-shadow: 0 4px 12px 0 hsla(0, 0%, 69%, 0.5);
  border-radius: 4px;
  padding-top: 16px;
  padding-bottom: 16px;

  &.isDark {
    background: #363b3f;
  }
}
.contextmenuContainer {
  position: fixed;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1a1a1a;

  &.isDark {
    color: #fff;

    .item {
      &:hover {
        background: hsla(0, 0%, 100%, 0.05);
      }
    }
  }

  .splitLine {
    width: 95%;
    height: 1px;
    background-color: #e9edf2;
    margin: 2px auto;
  }

  .item {
    position: relative;
    height: 28px;
    padding: 0 16px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.danger {
      color: #f56c6c;
    }

    &:hover {
      background: #f5f5f5;

      .subItems {
        visibility: visible;
      }
    }

    &.disabled {
      color: grey;
      cursor: not-allowed;
      pointer-events: none;

      &:hover {
        background: #fff;
      }
    }

    .name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .desc {
      color: #999;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .subItems {
      position: absolute;
      left: 100%;
      visibility: hidden;
      width: 150px;
      cursor: auto;

      &.showLeft {
        left: -150px;
      }
    }
  }
}
</style>
